module.exports = __webpack_public_path__ + "static/img/hala20.22e8c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala20.jpg
// module id = rUSZ
// module chunks = 1